/* Chocolate Counter — one-tap size chips on product cards + small site-wide helpers. V_1_1 (Oct 29, 2026). Pairs with snippets/product.tags.liquid.
   A chip adds that exact variant (¼ lb / ½ lb / 1 lb) to the cart with one request and opens the theme's cart drawer,
   the same way the box builder does. Delegated on document so AJAX-rendered grids (filters, sort) work too. */
(function () {
  let toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'cc-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('show'), 2600);
  }
  async function add(btn) {
    if (btn.disabled || btn.classList.contains('is-adding')) return;
    btn.classList.add('is-adding');
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +btn.dataset.ccAdd, quantity: 1 }], sections: 'cart-ajax' }) });
      const data = await res.json();
      if (!res.ok) { toast(data.description || data.message || 'Could not add that — please try again.'); return; }
      btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1400);
      const drawer = document.querySelector('header-cart-drawer');
      if (drawer && data.sections && data.sections['cart-ajax']) {
        drawer.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data } }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data } }));
      }
      toast((btn.dataset.ccName || 'Added') + ' — in your cart');
    } catch (e) { toast('Something went wrong adding that. Please try again.'); }
    finally { btn.classList.remove('is-adding'); }
  }
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-cc-add]'); if (!btn) return;
    e.preventDefault(); e.stopPropagation(); add(btn);
  }, true);

  // section titles: wrap the words in a span so the sage highlighter stroke (cc-theme.css .cc-hl) follows each line of text
  function markTitles(root) {
    (root || document).querySelectorAll('.section-header__title').forEach(h => {
      if (h.querySelector('.cc-hl') || !h.textContent.trim()) return;
      const s = document.createElement('span'); s.className = 'cc-hl';
      while (h.firstChild) s.appendChild(h.firstChild);
      h.appendChild(s);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => markTitles()); else markTitles();
  document.addEventListener('shopify:section:load', e => markTitles(e.target));
})();
